import { runAiJob } from './aiJobs';

export interface OutlineNode {
  title: string;
  summary: string;
  example?: string;
  subheadings: OutlineNode[];
}

export interface ChatTurn {
  role: 'user' | 'assistant';
  content: string;
  /** Quick-reply options offered alongside this turn; frontend-only, ignored by the API when echoed back. */
  choices?: string[];
}

export interface OutlineChatResult {
  message: string;
  outline: OutlineNode[];
  choices: string[];
}

export async function runOutlineChat(messages: ChatTurn[], context?: Record<string, string>): Promise<OutlineChatResult> {
  return runAiJob('/api/ai/outline-chat', { messages, context }, (poll) => ({
    message: poll.message ?? '',
    outline: (poll.outline as OutlineNode[] | undefined) ?? [],
    choices: poll.choices ?? []
  }));
}

/** A List property's value is the outline serialized as JSON; unusable/blank values are just an empty outline. */
export function parseOutline(value: string): OutlineNode[] {
  if (!value.trim()) return [];

  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? (parsed as OutlineNode[]) : [];
  } catch {
    return [];
  }
}

export function countOutlineNodes(nodes: OutlineNode[]): number {
  return nodes.reduce((total, node) => total + 1 + countOutlineNodes(node.subheadings ?? []), 0);
}

